import { Injectable } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FabService {
  private _items$ = new BehaviorSubject<MenuItem[]>([]);
  readonly items$ = this._items$.asObservable();

  private items: MenuItem[] = [];

  add(item: MenuItem) {
    this.items.push(item);
    this._items$.next(this.items);
  }

  remove(label: string) {
    this.items = this.items.filter((i) => i.label !== label);
    this._items$.next(this.items);
  }

  clear() {
    this.items = [];
    this._items$.next(this.items);
  }
}
